import { BodyLarge500, BodyMedium500 } from '@nebula/global-styles';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useMediaQuery } from '@nebula/hooks';
import { HorizontalProgressBar } from '@nebula/progress-bar';
import { StepIndicatorContainer, AriaHideContainer } from './stepIndicator.styles';

const StepIndicator = () => {
  const theme = useContext(ThemeContext);
  const isTabletLandscape = useMediaQuery(theme.media.tabletLandscapeMin);
  const BodyText = isTabletLandscape ? BodyLarge500 : BodyMedium500;

  return (
    <StepIndicatorContainer>
      <BodyText>Step 2 of 2</BodyText>
      <AriaHideContainer>
        <HorizontalProgressBar value={1} maxValue={1} color={theme.color.messaging.green[50]} />
      </AriaHideContainer>
    </StepIndicatorContainer>
  );
};

export default StepIndicator;
